import { TextField, styled } from '@mui/material';

export const RtlTextField = styled(TextField)({
  '& label': {
    transformOrigin: 'right !important',
    left: 'inherit !important',
    right: '1.75rem !important',
    fontSize: 'small',
    color: '#807D7B',
    fontWeight: 400,
    overflow: 'unset'
  },
  '& .MuiSvgIcon-root': {
    left: '2px !important',
    right: 'unset'
  },
  '& .MuiSelect-multiple': {
    paddingRight: '12px !important',
    paddingLeft: '24px !important'
  },
  '& legend': { textAlign: 'right' }
});
